<template>
  <ais-instant-search :index-name="this.paramProp['indexes']['job']" :search-client="searchClient">
    <AutoComplete page="home" :param-prop="params" />
  </ais-instant-search>
</template>

<script>
import { AisInstantSearch } from 'vue-instantsearch';

import { searchClient } from '../utils';

import AutoComplete from './AutoComplete.vue';

export default {
  name: 'HomepageAutocomplete',
  computed: {
    searchClient() {
      return searchClient;
    },
  },
  data() {
    return {
      params: JSON.stringify(this.paramProp),
    };
  },
  props: {
    paramProp: {
      default: undefined,
    },
  },
  components: {
    AisInstantSearch,
    AutoComplete,
  },
};
</script>
